module.exports = __webpack_public_path__ + "static/media/us.a72cfb6b.svg";